import { Component } from '@angular/core';
import { ResponsiveBaseComponent } from 'src/app/core/components/responsive-base/responsive-base.component';

@Component({
    selector: 'app-data-processing-agreement-page',
    templateUrl: './data-processing-agreement-page.component.html',
    styleUrl: './data-processing-agreement-page.component.scss',
    standalone: false
})
export class DataProcessingAgreementPageComponent extends ResponsiveBaseComponent {

}
